// extracted by mini-css-extract-plugin
export default {"table":"index_table__MffRL","hidden":"index_hidden__TFzjt","header":"index_header__nppqG","footer":"index_footer__Ze-1X"};